/**
 * www.santuariobasilicacoromoto.com
 * @author yadicksonvasquez@gmail.com
 * @updated 13/05/2025
 */

import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import posterImg from '../img/sliders/550/PosterEntradaBasilica463px.jpg';
import santaReliquia from '../img/sliders/550/santa-reliquia-virgen-coromoto-patrona-venezuela.jpg';
import virgenCoromoto from '../img/sliders/550/santa-reliquia-virgen-coromoto.jpg';
import image1 from '../img/sanctuary/donationsSliders.jpg';
import md_hallazgos3 from '../img/gallery-holy-relic/2176_850/santa-reliquia-coromoto-1450.jpg';
import md_hallazgos2 from '../img/gallery-holy-relic/2176_850/sliderVirgenCoromoto.jpg';
import md_hallazgos1 from '../img/gallery-holy-relic/2176_850/holy-relic-coromoto-370.jpg';
import md_hallazgos4 from '../img/gallery-holy-relic/2176_850/sliderSantaReliquiaVirgenCoromoto.jpg';

export default class DonationsSanctuarySliders extends Component {

    render() {
        return (
            <div className="row">
                <div className="col-xl-12 col-lg-12 d-sm-none d-none d-md-none d-xl-block d-lg-block" style={{ 'marginTop': '173px' }}>
                    <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showStatus={false}>
                        <div>
                            <img src={image1} alt='Basilica Menor Santuario Nacional Nuestra Señora de Coromoto' />
                        </div>
                    </Carousel>
                </div>
                <div className="col-12 d-xl-none d-lg-none d-md-block d-sm-block d-none" style={{ 'marginTop': '80px' }}>
                    <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showStatus={false}>
                        <div>
                            <img src={md_hallazgos2} alt="Virgen de Coromoto" />
                        </div>
                        <div>
                            <img src={md_hallazgos4} alt="Virgen de Coromoto" />
                        </div>
                        <div>
                            <img src={md_hallazgos1} alt="Virgen de Coromoto" />
                        </div>
                        <div>
                            <img src={md_hallazgos3} alt="Virgen de Coromoto" />
                        </div>
                    </Carousel>
                </div>
                <div className="col-12 d-xl-none d-lg-none d-md-none d-sm-block d-block" style={{ 'marginTop': '80px' }}>
                    <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showStatus={false}>
                        <div>
                            <img src={santaReliquia} alt='Basilica Menor Santuario Nacional Nuestra Señora de Coromoto' />
                        </div>
                        <div>
                            <img src={virgenCoromoto} alt='Basilica Menor Santuario Nacional Nuestra Señora de Coromoto' />
                        </div>
                        <div>
                            <img src={posterImg} alt='Basilica Menor Santuario Nacional Nuestra Señora de Coromoto' />
                        </div>
                    </Carousel>
                </div>
            </div>);
    }

}